import { markUiObject as __markUi, translateUi as __ui } from '@/i18n/display'
import {computed, onBeforeUnmount, ref, watch} from 'vue'
import store from '@/store'
import customerRequest from '@/api/customer'
import {message} from 'ant-design-vue'

export const catalogPaths = new Set(['/main/bokes','/main/cloths','/main/retails','/main/fabrics','/main/accessories','/main/decorations','/main/buycourse'])
const intentKey = 'ld-catalog-share-login'
type Intent = {orgId:number; path:string; time:number}

export function useCatalogReferral(route:any) {
  const enabled=ref(false), shareVisible=ref(false), shareUrl=ref('')
  const visible=computed(()=>catalogPaths.has(route.path) && enabled.value)
  const identity=()=>JSON.stringify([store.getters.orgId,store.getters.userInfo?.id,store.getters.token])
  const loggedIn=()=>Boolean(store.getters.token) && Number(store.getters.userInfo?.id)>0
    && Number(store.getters.userInfo?.orgId)===Number(store.getters.orgId)
  let request=0, timer:ReturnType<typeof setTimeout>|undefined, pending:Intent|null=null
  try{pending=JSON.parse(sessionStorage.getItem(intentKey)||'null')}catch{ /* 禁用存储时仍支持当前页登录。 */ }
  const clearIntent=()=>{pending=null;try{sessionStorage.removeItem(intentKey)}catch{ /* 可选缓存。 */ }}
  const currentIntent=()=>pending && pending.orgId===Number(store.getters.orgId) && pending.path===route.path
    && Date.now()-pending.time>=0 && Date.now()-pending.time<300000
  const makeUrl=()=>{
    // 只分享当前门店与目录，不传播旧推荐人、搜索词和其他入口参数。
    const url=new URL(route.path,window.location.origin)
    url.searchParams.set('orgId',String(store.getters.orgId))
    url.searchParams.set('referrerId',String(store.getters.userInfo.id))
    return url.toString()
  }
  const send=async()=>{
    if(!visible.value || !loggedIn())return
    const snapshot=identity(),url=makeUrl()
    shareUrl.value=url
    if(navigator.share){
      try{await navigator.share(__markUi({title:'推荐朋友来看看',url}, {"title":"推荐朋友来看看"}));shareVisible.value=false;return}
      catch(error:any){if(error?.name==='AbortError')return}
    }
    if(snapshot!==identity() || !visible.value)return
    try{
      await navigator.clipboard.writeText(url)
      if(snapshot===identity()){shareVisible.value=false;message.success(__ui('分享链接已复制，可发送给朋友'))}
    }catch{if(snapshot===identity())shareVisible.value=true}
  }
  const shareCatalog=()=>{
    if(!visible.value)return
    if(!loggedIn()){
      pending={orgId:Number(store.getters.orgId),path:route.path,time:Date.now()}
      try{sessionStorage.setItem(intentKey,JSON.stringify(pending))}catch{ /* 可选缓存。 */ }
      store.state.user.loginCallback?.()
      return
    }
    clearIntent()
    return send()
  }
  watch(()=>[route.path,store.getters.orgId],async()=>{
    const ticket=++request,orgId=Number(store.getters.orgId)
    enabled.value=false;shareVisible.value=false
    if(pending && !currentIntent())clearIntent()
    if(!catalogPaths.has(route.path) || !Number.isSafeInteger(orgId) || orgId<=0)return
    try{
      const result=await customerRequest.listShareCouponEnabled(orgId)
      if(ticket===request)enabled.value=result.data===true
    }catch{ /* 保留原返券活动开关，查询失败时不承诺返券。 */ }
  },{immediate:true,flush:'sync'})
  watch(()=>[visible.value,identity()],()=>{
    if(timer)clearTimeout(timer)
    if(!loggedIn())shareVisible.value=false
    if(!currentIntent()){if(pending)clearIntent();return}
    if(!visible.value || !loggedIn())return
    // 密码登录会刷新页面：意图保留到新页面；短信登录则在当前页继续。
    timer=setTimeout(()=>{
      if(!currentIntent() || !visible.value || !loggedIn())return
      clearIntent();void send()
    },250)
  },{immediate:true})
  onBeforeUnmount(()=>{request++;if(timer)clearTimeout(timer)})
  return {visible,shareVisible,shareUrl,shareCatalog,send}
}
